import { useHabits as _useHabits } from '@griply/hooks';
import { Habit } from '@griply/types';
import { DeletedFilter, DeletedFilterOption } from '@griply/utils';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { GetTaskOptions } from 'shared/services/backend-api';
import { TaskType } from 'shared/types/task-base';

export type Options = Omit<GetTaskOptions, 'type'> & DeletedFilterOption;

export const useHabits = ({
  deletedFilter = DeletedFilter.ExcludeDeleted,
  ...options
}: Options = {}): Habit[] => {
  const user = useUser();
  const { data } = useTasksQuery(
    user?.uid,
    { ...options, type: TaskType.Habit },
    true,
    { deletedFilter },
  );
  return _useHabits({ tasks: data ?? [] });
};
